import Vue from 'vue';
import ZSourceSelector from '../components/ZSourceSelector'
import ZNotify from '../components/ZNotify'

function plugins(Vue) {
  Vue.component('z-source-selector',ZSourceSelector)
  Vue.component('z-notify',ZNotify)

}

export default plugins